import { render } from "./RandomArtist.vue?vue&type=template&id=346ce73b"
import script from "./RandomArtist.vue?vue&type=script&lang=js"
export * from "./RandomArtist.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macbook/Mubasher/Mubasher/Projects/Live/bling-rock/Project-Live/soundcode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__